<template>
  <div class="index">
    <div class="slider-banner banner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item, index) in info.slider_image" :key="index">
          <img class="swiper-img" :src="item" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="gradient-bg"></div>
    <div class="child-info">
      <img class="child-head" :src="info.image_input" alt="">
      <div>
        <div class="child-name">
          <div>{{ info.nickname }}</div>
          <img class="gender-img" :src="`${require('@assets/images/dywfl/gender1.png')}`" alt="" v-if="info.sex == '男'">
          <img class="gender-img" :src="`${require('@assets/images/dywfl/gender1.png')}`" alt="" v-else>
        </div>
        <div class="child-time">{{ info.add_time }}</div>
      </div>
    </div>
    <div class="concat-info">
      <div class="concat-item">
        <img :src="`${require('@assets/images/dywfl/help-icon1.png')}`" alt=""> {{ info.phone }}
      </div>
      <div class="concat-item">
        <img :src="`${require('@assets/images/dywfl/help-icon2.png')}`" alt=""> {{ info.address }}
      </div>
    </div>

    <div class="story-container">
      <div class="store-title">故事介绍</div>
      <div class="intro-container" v-html="info.content">
      </div>
    </div>

    <div style="height: 1.8rem;"></div>
    <Leader @confirmCheck="confirmCheck" @cancelCheck="cancelCheck"></Leader>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getDetail ,Examine} from "@api/public";
import Leader from "@/components/Leader.vue";
import Loading from "@components/Loading";
export default {
  name: "CateList",
  components: {
    swiper,
    swiperSlide,
    Leader,
	Loading
  },
  props: {},
  data: function () {
    return {
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },//swiper设置
      id: 0,
      info: {},
	  loaded: false,
	  loading: false,
    };
  },
  watch: {

  },
  created(option) {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  mounted: function () {
  },
  methods: {
    confirmCheck() {
      this.$dialog.loading.open("正在加载中");
      let data={};
        data.id = this.id;
        data.nav = 3;
        data.is_leader_check_status=1;
      Examine(data).then(res => {
		this.$dialog.loading.close();
		this.$dialog.success(res.msg);
		setTimeout(() => {
		  this.$router.go(-1)
		}, 1000);
      }).catch(res=>{
		this.$dialog.loading.close();
		this.$dialog.error(res.msg);
      });
    },
    cancelCheck(e) {
	  this.$dialog.loading.open("正在加载中");
	  let data={};
	    data.id = this.id;
	    data.nav = 3;
	    data.is_leader_check_status=2;
	    data.leader_check_fail_remarks=e;
	  Examine(data).then(res => {
	  	this.$dialog.loading.close();
	  	this.$dialog.success(res.msg);
	  	setTimeout(() => {
	  	  this.$router.go(-1)
	  	}, 1000);
	  }).catch(res=>{
	  	this.$dialog.loading.close();
	  	this.$dialog.error(res.msg);
	  });
    },
    getDetail() {
      getDetail(this.id).then(res => {
        this.info = res.data
      });
    },
    goPage(url) {
      this.$router.push({ path: url });
    }
  },
};
</script>
<style>
.story-container .intro-container p {
  font-size: 0.32rem !important;
}

.story-container .intro-container img {
  width: 100%;
  display: block;
}
</style>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #f3f3f3;
}

.gradient-bg {
  height: 2.68rem;
  background: linear-gradient(0deg, #f3f3f3 0%, #FF93A9 100%);
  margin-bottom: -2.46rem;
}

.child-info {
  display: flex;
  align-items: center;
  padding-bottom: .3rem;
  background-color: #fff;
  margin: 0 .2rem;
  padding: .3rem;
  border-radius: .2rem;

  .child-head {
    width: .85rem;
    height: .85rem;
    border-radius: .1rem;
    margin-right: .2rem
  }

  .child-name {
    display: flex;
    align-items: flex-start;
    font-size: .28rem;
  }

  .child-time {
    font-size: .24rem;
    color: #999;
    margin-top: .05rem;
  }

  .gender-img {
    width: .16rem;
    height: .16rem;
  }
}

.concat-info {
  border-radius: .2rem;
  background-color: #fff;
  padding: 0 .2rem;
  margin: .3rem .2rem 0;

  .concat-item {
    height: .9rem;
    padding: 0 .2rem;
    display: flex;
    align-items: center;

    .iconfont {
      color: #FF5B83;
    }

    img {
      width: .37rem;
      height: .37rem;
      vertical-align: bottom;
      margin-right: .2rem;
    }

    &~.concat-item {
      border-top: 1px solid #EBEBEB;
    }
  }
}

.story-container {
  padding: .3rem;
  margin: .3rem .2rem 0;
  border-radius: .2rem;
  background-color: #fff;
  min-height: 6rem;

  .store-title {
    font-size: .36rem;
    font-weight: bold;
  }

  .intro-container {
    min-height: 7.2rem;
    overflow: hidden;
    font-size: 0.32rem !important;
    color: #8A8B8C !important;
    line-height: 1.8;
    word-wrap: break-word;
    word-break: normal;
  }
}

.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  width: 100vw;
  padding: .3rem .2rem;
  box-shadow: 0 0 .2rem #F3F3F3;

  .help-btn {
    line-height: .9rem;
    border-radius: .9rem;
    text-align: center;
    background-color: #FF5B83;
    color: #fff;
  }
}

.intro-container p {
  font-size: 0.32rem !important;
}
</style>
